import React, {Component} from 'react';
import './Loader.css';
import loader from '../img/loading.gif';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

library.add(faSpinner);

class Loader extends Component{

    render(){
        if(this.props.box){
            return (
                <div className="overlay">
                    {/*<i className="fa fa-refresh fa-spin"></i>*/}
                    <div className="center-block">
                        <FontAwesomeIcon icon="spinner" spin={true}/>
                    </div>
                </div>
            );
        }else{
            return (
                <div className="loader">
                    <div className="center-block">
                        <img src={loader} alt="" />
                    </div>

                </div>
            );
        }
    }
}

export default Loader;


// WEBPACK FOOTER //
// ./src/Loader/Loader.js